export function updateSearchParams(params: [string, string | null][]) {
  const url = new URL(window.location.href);

  for (const [key, value] of params) {
    if (value === null) {
      url.searchParams.delete(key);
    } else {
      url.searchParams.set(key, value);
    }
  }

  history.replaceState(null, "", url);
}
